import { ObstructionType } from './ObstructionType.model'
import { Trail } from './Trail.model'
import { TrailSystem } from './TrailSystem.model'
import { AppRegions } from './AppRegions.model'

type RequiredFields = 'name' | 'symbol' | 'sortWeight' | 'active'

export type ObstructionTypeForReport = Required<Pick<ObstructionType, RequiredFields>> &
  Partial<Omit<ObstructionType, RequiredFields>>

export type ObstructionReport = {
  alertLevel: string
  id: number
  trail: Trail
  obstructionType: ObstructionTypeForReport
  obstructionDescription: string
  statusDescription: string
  reporterEmail: string
  region: {
    code: AppRegions
    name: string
  }
  imageUrl?: string
  gpsLat: string
  gpsLong: string
  reportedAt: string
  expiryDate: string
  system: TrailSystem
  archived?: boolean
}

// we offer this to enable the enumerate the ObstructionReport type's fields in js/ts files
export const obstructionReportFields: (keyof ObstructionReport)[] = [
  'id',
  'alertLevel',
  'trail',
  'obstructionType',
  'obstructionDescription',
  'statusDescription',
  'reporterEmail',
  'imageUrl',
  'gpsLat',
  'gpsLong',
  'reportedAt',
  'archived',
]
